import { render, staticRenderFns } from "./LocalizationBtn.vue?vue&type=template&id=768e6a36"
import script from "./LocalizationBtn.vue?vue&type=script&lang=js"
export * from "./LocalizationBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports